import ko from 'knockout';
import { _isFunction } from 'underscore-es/_objects';
'use strict';

export function registerComponent() {
  ko.components.register('dropdown-popup', {
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new DropdownPopupViewModel(params, componentInfo);
      },
    },
    template: '<label>\
            <span class="label-text" data-bind="text: label"></span>\
            <span class="show-input-delete-icon">\
              <input placeholder=" " type="text" class="form-control" data-bind="click: togglePopup, value: content" readonly="readonly" />\
              <span class="input-delete-icon" data-bind="click: clear"></span>\
            </span>\
          </label>\
          <div class="dropdown-popup" data-bind="visible: shouldShowPopup">\
            <div class="dropdown-popup-header">\
              <span data-bind="click: togglePopup"><i class="custom-icon close-icon"></i></span>\
              <h3 data-bind="text: label"></h3>\
            </div>\
            <div data-bind="component: { name: component, params: { data: data, content: content, close: close, onOpen: onOpenEvent, onClear: onClearEvent } }"></div>\
          </div>',
  });
}

function DropdownPopupViewModel(params, componentInfo) {
  var self = this;
  var onOpenEventHandler = null;
  var onClearEventHandler = null;

  self.shouldShowPopup = ko.observable(false);
  self.content = ko.observable('');
  self.label = params.label;
  self.component = params.component;
  self.data = params.data;

  document.addEventListener('click', function (event) {
    var isClickInside = componentInfo.element.contains(event.target);

    if (!isClickInside) {
      self.shouldShowPopup(false);
    }
  });

  self.shouldShowPopup.subscribe(function (visible) {
    if (visible) {
      document.body.classList.add('dropdown-popup-visible');
      if (_isFunction(onOpenEventHandler)) {
        onOpenEventHandler();
      }
    } else {
      document.body.classList.remove('dropdown-popup-visible');
    }
  });

  self.togglePopup = function () {
    self.shouldShowPopup(!self.shouldShowPopup());
  };

  self.close = function () {
    self.shouldShowPopup(false);
  };

  self.clear = function () {
    if (_isFunction(onClearEventHandler)) {
      onClearEventHandler();
    }
  };

  self.onOpenEvent = function dropdownPopupAddOpenEventHandler(handlerFn) {
    onOpenEventHandler = handlerFn;
  };

  self.onClearEvent = function dropdownPopupAddClearEventHandler(handlerFn) {
    onClearEventHandler = handlerFn;
  };
}
